import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useUserBlocks } from '@/hooks/useUserBlocks';
import { Ban } from 'lucide-react';

export function BlockedUsersList() {
  const { blockedUsers, isLoading, unblockUser, isUnblocking } = useUserBlocks();

  if (isLoading) {
    return (
      <Card>
        <CardContent className="py-8">
          <p className="text-center text-muted-foreground">Loading blocked users...</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Ban className="w-5 h-5" />
          Blocked Users
        </CardTitle>
        <CardDescription>
          Users you've blocked won't appear in your feeds or activities
        </CardDescription>
      </CardHeader>
      <CardContent>
        {blockedUsers.length === 0 ? (
          <div className="text-center py-8">
            <Ban className="w-12 h-12 mx-auto mb-3 text-muted-foreground" />
            <p className="text-muted-foreground">You haven't blocked anyone</p>
          </div>
        ) : (
          <div className="space-y-4">
            {blockedUsers.map((block: any) => (
              <div
                key={block.id}
                className="flex items-center justify-between p-3 rounded-lg border bg-card"
              >
                <div className="flex items-center gap-3">
                  <Avatar className="h-10 w-10">
                    <AvatarImage src={block.profiles?.image} />
                    <AvatarFallback>
                      {block.profiles?.username?.charAt(0)?.toUpperCase() || 'U'}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <p className="font-medium">@{block.profiles?.username}</p>
                    {block.profiles?.name && (
                      <p className="text-sm text-muted-foreground">{block.profiles.name}</p>
                    )}
                  </div>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => unblockUser(block.blocked_id)}
                  disabled={isUnblocking}
                >
                  Unblock
                </Button>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
